import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getAccessToken, removeToken } from '@/utils/auth'
import { getInfo, loginOut } from '@/api/login/LoginAPI'
import { getUserProfile } from '@/api/system/user/profile'

const initState = {
  isSetUser: false,
  token: '',
  user: {
    id: 0,
    avatar: '',
    nickname: '',
    username: '',
    mobile: '',
    defaultPage: '',
    dept: {
      id: 0,
      name: '',
    },
    email: '',
    sex: 0,
    roles: [],
    createTime: undefined,
  },
}

export const useUserStore = defineStore(
  'user',
  () => {
    const userInfo = ref<UserInfoVO>({ ...initState })

    // actions methods
    const setUserInfoAction = async () => {
      const accesstoken = getAccessToken()
      if (!accesstoken) {
        // 获取不到accessToken，直接返回
        resetState()
        return
      }

      const res = await getUserProfile()
      userInfo.value = {
        isSetUser: false,
        token: accesstoken,
        user: {
          id: res.id,
          avatar: res.avatar,
          nickname: res.nickname,
          username: res.username,
          mobile: res.mobile,
          defaultPage: res.defaultPage,
          dept: {
            id: res.dept.id,
            name: res.dept.name,
          },
          email: res.email,
          sex: res.sex,
          roles: [...res.roles],
          createTime: res.createTime,
        },
      }
    }

    const setUserAvatarAction = async (avatar: string) => {
      userInfo.value.user.avatar = avatar
    }

    const setUserNicknameAction = async (nickname: string) => {
      userInfo.value.user.nickname = nickname
    }

    const LogOut = async () => {
      await loginOut()
      removeToken()
      resetState()
    }

    const resetState = () => {
      console.log('initState', initState)
      userInfo.value = initState
      console.log('重置userInfo', userInfo.value)
    }
    const isLogined = computed(() => !!userInfo.value.token)
    // 暴露到外面的方法
    return {
      userInfo,
      setUserInfoAction,
      setUserAvatarAction,
      setUserNicknameAction,
      LogOut,
      resetState,
      isLogined,
    }
  },
  {
    // 持久化
    persist: true,
  },
)
